import moment from "moment";
import { unstable_useMediaQuery as useMediaQuery } from "@material-ui/core/useMediaQuery";
import { breakpoints } from "./breakpoints";

function Comatose(s) {
  return s
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function DateFormat(s) {
  let months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let d = new Date(s);

  return months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
}

function TimeFormat(s) {
  let d = new Date(s);
  return d.toLocaleTimeString();
}

function DateTimeFormat(s) {
  let d = new Date(s);
  return moment(d.toString()).format("MMMM D, YYYY h:mm A");
}

function ToUrlFormat(str) {
  return str.replace(/\W+/g, "-").toLowerCase();
}

function LinkState(self, fieldName) {
  return {
    value: self.state[fieldName],
    requestChange: function (newValue) {
      let delta = {};
      delta[fieldName] = newValue;
      self.setState(delta);
    },
  };
}

function handleChange(e, transformer = (value) => value) {
  e.preventDefault();
  const { value, name } = e.target;
  if (name)
    this.setState({
      [name]: transformer(value),
    });
}

function mapPricingTableData(tier, pricingTableData) {
  return {
    header: { [tier]: pricingTableData.header[tier] },
    footer: { [tier]: pricingTableData.footer[tier] },
    sections: pricingTableData.sections.map((s) => ({
      title: s.title,
      rows: s.rows.map((sr) => ({
        title: sr.title,
        value: { [tier]: sr.value[tier] },
      })),
    })),
  };
}

const mq = (breakpoint) =>
  `@media (min-width: ${breakpoints.values[breakpoint]}px)`;

const useMq = (breakpoint) => useMediaQuery(mq(breakpoint));

export {
  Comatose,
  DateFormat,
  TimeFormat,
  DateTimeFormat,
  ToUrlFormat,
  LinkState,
  handleChange,
  mapPricingTableData,
  mq,
  useMq,
};



// WEBPACK FOOTER //
// ./js/components/helpers/utils.js